import * as React from 'react';
var context = React.createContext({});
export var UserContextProvider = context.Provider;
export var UserContextConsumer = context.Consumer;
export var UserContext = context;
//# sourceMappingURL=user.js.map